import React, { useState } from 'react';
import { FaEnvelope, FaMapMarkerAlt, FaPhoneAlt } from 'react-icons/fa';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: ''
  });
  const [status, setStatus] = useState('');

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    setStatus('Отправка...');

    try {
      const response = await fetch('https://hisphere.net:7001/api/contact', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      });

      const result = await response.json();

      if (response.ok) {
        setStatus('Сообщение отправлено успешно!');
        setFormData({ name: '', email: '', message: '' });
      }

      else setStatus(result.error || 'Ошибка отправки. Попробуйте снова.');
    } catch (error) {
      setStatus('Ошибка отправки. Проверьте подключение.');
    }
  };

  const contactInfo = [
    { icon: <FaMapMarkerAlt />, title: 'Наш адрес', description: 'г. Усть-Илимск, ул. Черехумовая, 1' },
    { icon: <FaPhoneAlt />, title: 'Номер телефона', description: '+7 (904) 146-49-64' },
    { icon: <FaEnvelope />, title: 'Электронная почта', description: 'admin@hisphere.net' }
  ];

  return (
    <section className='py-32 bg-gray-100 dark:bg-gray-900 relative overflow-hidden'>
      <div className='before:content-[""] before:absolute before:-bottom-80 before:-left-80 before:w-[800px] before:h-[800px] before:bg-gradient-rad convective-radial before:from-pink-400/10 before:to-transparent before:z-0 before:animate-pulse'></div>
      <div className='container mx-auto px-8 max-w-7xl relative z-10'>
        <div className='text-center mb-20 animate'>
          <h2 className='text-5xl font-montserrat font-bold bg-gradient-to-r from-blue-500 to-cyan-400 bg-clip-text text-transparent relative mb-6
            after:content-[""] after:absolute after:bottom-[-10px] after:left-1/2 after:-translate-x-1/2 after:w-20 after:h-1 after:bg-gradient-to-r after:from-pink-500 after:to-purple-600 after:rounded'>
            Связаться с нами
          </h2>
          <p className='text-xl text-gray-600 dark:text-gray-400 max-w-3xl mx-auto'>
            Мы здесь, чтобы помочь! Свяжитесь с нами по любым вопросам.
          </p>
        </div>
        <div className='flex flex-col lg:flex-row gap-12'>
          <div className='flex-1 flex flex-col gap-8'>
            {contactInfo.map((info, index) => (
              <div
                key={index}
                className='info-item bg-white/80 dark:bg-gray-800/70 p-6 rounded-2xl shadow-sm hover:shadow-md hover:-translate-y-1 transition-all duration-300 backdrop-blur-md animate'
              >
                <div className='w-14 h-14 bg-gradient-to-br from-blue-500 to-indigo-800 rounded-xl flex items-center justify-center text-white text-xl transition-all duration-300 hover:rotate-12 hover:bg-gradient-to-br hover:from-pink-500 hover:to-purple-600 hover:shadow-lg'>
                  {info.icon}
                </div>
                <div>
                  <h3 className='text-xl font-montserrat font-bold mb-2 text-gray-900 dark:text-white'>{info.title}</h3>
                  <p className='text-gray-600 dark:text-gray-400'>{info.description}</p>
                </div>
              </div>
            ))}
          </div>
          <form onSubmit={handleSubmit} className='flex-1 bg-white/90 dark:bg-gray-800/80 p-8 rounded-3xl shadow-lg transition-all duration-300 backdrop-blur-md animate'>
            <div className='flex flex-col lg:flex-row gap-6 mb-6'>
              <div className='flex-1'>
                <label className='block mb-2 font-semibold text-gray-900 dark:text-gray-200'>Имя</label>
                <input
                  type='text'
                  name='name'
                  value={formData.name}
                  onChange={handleChange}
                  className='w-full p-3 border border-gray-200 dark:border-gray-600 rounded-xl bg-gray-50/70 dark:bg-gray-700/50 text-gray-900 dark:text-gray-200 focus:outline-none focus:border-blue-500 focus:ring-2 focus:ring-blue-500/20 transition-all duration-200'
                  placeholder='Ваше имя'
                  required
                />
              </div>
              <div className='flex-1'>
                <label className='block mb-2 font-semibold text-gray-900 dark:text-gray-200'>Электронная почта</label>
                <input
                  type='email'
                  name='email'
                  value={formData.email}
                  onChange={handleChange}
                  className='w-full p-3 border border-gray-200 dark:border-gray-600 rounded-xl bg-gray-50/70 dark:bg-gray-700/50 text-gray-900 dark:text-gray-200 focus:outline-none focus:border-blue-500 focus:ring-2 focus:ring-blue-500/20 transition-all duration-200'
                  placeholder='Ваш email'
                  required
                />
              </div>
            </div>
            <div className='mb-6'>
              <label className='block mb-2 font-semibold text-gray-900 dark:text-gray-200'>Сообщение</label>
              <textarea
                name='message'
                value={formData.message}
                onChange={handleChange}
                className='w-full p-3 border border-gray-200 dark:border-gray-600 rounded-xl bg-gray-50/70 dark:bg-gray-700/50 text-gray-900 dark:text-gray-200 focus:outline-none focus:border-blue-500 focus:ring-2 focus:ring-blue-500/20 transition-all duration-200 min-h-[180px] resize-y'
                placeholder='Ваше сообщение'
                required
              ></textarea>
            </div>
            <button
              type='submit'
              className='bg-gradient-to-br from-pink-500 to-purple-600 text-white font-bold py-3 px-6 rounded-xl shadow-lg hover:shadow-xl hover:-translate-y-1 hover:bg-gradient-to-br hover:from-purple-600 hover:to-pink-500 transition-all duration-300'
            >
              Отправить сообщение
            </button>
            {status && (
              <p className={`text-center mt-4 ${status.includes('успешно') ? 'text-green-500' : 'text-red-500'}`}>
                {status}
              </p>
            )}
          </form>
        </div>
      </div>
    </section>
  );
};

export default Contact;
